// extracted by mini-css-extract-plugin
export default {"header":"Header_header__Lhnr8","logo":"Header_logo__nZ7K6","nav":"Header_nav__ZwnMZ"};